<template>
  <introduction v-if="content.category === 'introduction'" :content="content"></introduction>
</template>
<script>
/*
特殊组件
*/
import introduction from "./introduction.vue";
export default {
  name: "titleIndex",
  components: {
    introduction,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
}
</script>